import React from "react";
import { Box, Stack, TextField, MenuItem, Typography, InputAdornment } from "@mui/material";
import { Link as LinkIcon } from "../../icons/FigmaControlIcons";
import BusinessIcon from "@mui/icons-material/Business";

const PURPLE = "#7C3AED";
const SOFT_BORDER = "#EAE5FF";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 10,
    bgcolor: "#fff",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: SOFT_BORDER,
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D7CBFF",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: PURPLE,
    borderWidth: 2,
  },
};

function LabelText({ children }) {
  return (
    <Typography data-popup-label sx={{ fontSize: 14, fontWeight: 500, lineHeight: 1, color: "#6B7280", mb: 0.6 }}>
      {children}
    </Typography>
  );
}

export default function UseLinkCandidateStep({
  linkValue,
  companyName,
  source,
  errors,
  sourceOptions,
  onCompanyChange,
  onLinkChange,
  onSourceChange,
}) {
  return (
    <Box sx={{ p: 4 }}>
      <Stack spacing={1.25}>
        <Box>
          <LabelText>Company (Client)</LabelText>
          <TextField
            value={companyName}
            onChange={onCompanyChange}
            placeholder="Hourglass"
            fullWidth
            size="small"
            error={!!errors?.company_client}
            helperText={
              errors?.company_client ||
              "If the company doesn't exist yet, we'll create it when you continue."
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon sx={{ fontSize: 18, color: PURPLE }} />
                </InputAdornment>
              ),
            }}
            sx={fieldSx}
          />
        </Box>

        <Box>
          <LabelText>Enter link</LabelText>
          <TextField
            value={linkValue}
            onChange={onLinkChange}
            placeholder="https://www.linkedin.com/in/..."
            fullWidth
            size="small"
            error={!!errors?.linkedin_url}
            helperText={errors?.linkedin_url || ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LinkIcon sx={{ fontSize: 18, color: PURPLE }} />
                </InputAdornment>
              ),
            }}
            sx={fieldSx}
          />
        </Box>

        <Box>
          <LabelText>Select Source</LabelText>
          <TextField
            select
            value={source}
            onChange={onSourceChange}
            fullWidth
            size="small"
            sx={fieldSx}
          >
            {sourceOptions.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Stack>
    </Box>
  );
}
